export const BROADCAST_DELAY_SECONDS = 40;
export const QUALITIES_DEFAULT = [480, 720, 1080];
